import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var BaseballBall = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 512 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M62.7 223.4c-4.8.4-9.7.6-14.7.6-15.6 0-30.8-2-45.2-5.9C19.2 107.1 107.1 19.2 218.1 2.8 222 17.2 224 32.4 224 48c0 4.9-.2 9.8-.6 14.7-.7 8.8 5.8 16.5 14.6 17.3s16.5-5.8 17.3-14.6c.5-5.7.7-11.5.7-17.3 0-16.5-1.9-32.6-5.6-47.9 1.8 0 3.7-.1 5.6-.1C397.4 0 512 114.6 512 256c0 1.9 0 3.7-.1 5.6-15.4-3.6-31.4-5.6-47.9-5.6-5.8 0-11.6.2-17.3.7-8.8.7-15.4 8.5-14.6 17.3s8.5 15.4 17.3 14.6c4.8-.4 9.7-.6 14.7-.6 15.6 0 30.8 2 45.2 5.9-16.5 111-104.4 198.9-215.4 215.3-3.9-14.4-5.9-29.6-5.9-45.2 0-4.9.2-9.8.6-14.7.7-8.8-5.8-16.5-14.6-17.3s-16.5 5.8-17.3 14.6c-.5 5.7-.7 11.5-.7 17.3 0 16.5 1.9 32.6 5.6 47.9-1.8 0-3.7.1-5.6.1C114.6 512 0 397.4 0 256c0-1.9 0-3.7.1-5.6 15.3 3.7 31.4 5.6 47.9 5.6 5.8 0 11.6-.2 17.3-.7 8.8-.7 15.4-8.5 14.6-17.3s-8.5-15.4-17.3-14.6zm58.6-15.4c-8 3.7-11.6 13.2-7.9 21.2s13.2 11.6 21.2 7.9c45.2-20.8 81.7-57.2 102.5-102.5 3.7-8 .2-17.5-7.9-21.2s-17.5-.2-21.2 7.9c-17.6 38.3-48.5 69.2-86.7 86.7zm277.2 74.7c-3.7-8-13.2-11.6-21.2-7.9-45.2 20.8-81.7 57.2-102.5 102.5-3.7 8-.2 17.5 7.9 21.2s17.5.2 21.2-7.9c17.6-38.3 48.5-69.2 86.7-86.7 8-3.7 11.6-13.2 7.9-21.2z"
  }));
});
BaseballBall.displayName = 'BaseballBall';
export var BaseballBallDimensions = {
  height: 512,
  width: 512
};